import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M9.999 10.835a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M15.832 10.835a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M4.165 10.835a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
    }, null, -1)
  ]))]))
}
export default { render: render }